import React from "react";
import DoctorRegisterForm from "../Components/Forms/DoctorRegisterForm";
import Footer from "../Components/Footer";
import LifeDocLogoWhite from "../Assets/LifeDlogoWhite.png";
import wavey from "../Assets/wavey.svg";
import doctor from "../Assets/doctor.png";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import ArrowBackRoundedIcon from "@material-ui/icons/ArrowBackRounded";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "hsl(0, 0%, 100%)",
    background: `url(${wavey})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center bottom",
    backgroundSize: "200%",
    height: "121vh",
    maxWidth: "100vw",
  },
  paper: {
    margin: "auto",
    padding: theme.spacing(2),
    borderRadius: 12,
    maxWidth: 450,
    textAlign: "center",
    borderTop: "6px solid #ffc947",
    boxShadow: "0 4px 6px 0 hsla(0, 0%, 0%, 0.2)",
    //zIndex: 9,
  },
  doctor: {
    //float: "center",
    width: "650px",
    margin: "50px",
    //position: "relative",
    //zIndex: -1,
  },
  backButton: {
    color: theme.palette.common.blue,
    height: 50,
    width: 50,
    transition: theme.transitions.create(["transform"], {
      duration: theme.transitions.duration.complex,
    }),
    "&:hover": {
      transform: "translateX(20px)",
    },
  },
}));

const DoctorRegister = () => {
  const classes = useStyles();

  return (
    <Container className={classes.root}>
      <a href="/">
        <ArrowBackRoundedIcon className={classes.backButton} />
      </a>
      <Grid
        container
        spacing={2}
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item lg={2}>
          <img src={doctor} alt="doctor" className={classes.doctor} />
        </Grid>
        <Grid item lg={10}>
          <Paper className={classes.paper}>
            <DoctorRegisterForm />
          </Paper>
        </Grid>

        <Grid item lg={12}>
          <Footer logo={LifeDocLogoWhite} textColor="white" />
        </Grid>
      </Grid>
    </Container>
  );
};

export default DoctorRegister;
